import { styled } from '@mui/material/styles';

export const StyledForm = styled('form')`
  margin: 1em;
  max-width: 640px;
  min-width: 300px;
  font-size: large;
`;
